module.exports = __webpack_public_path__ + "img/cns_printer_pc12.e1689235.png";